@if (data.type === 'album') {
  <div class="flex justify-between w-full">
    <div class="overflow-wrap text-ellipsis truncate max-w-64">
      <i class="pi pi-{{ iconNameSet(data) }}"></i>
      {{
        data.name
          ? data.name
          : (data.file_name ? data.file_name : '') + (data.extension ? data.extension : '')
      }}
    </div>
    <div class="flex gap-1">
      <span
        class="w-6 h-6 text-center cursor-pointer rounded-full box-bg hover:bg-primary"
        title="{{ 'Actions' | translate }}"
        (click)="foldersMenu.toggle($event); $event.stopPropagation()">
        <i class="pi pi-ellipsis-v" style="font-size: 12px"></i>
      </span>
      <span
        class="w-6 h-6 text-center cursor-pointer rounded-full box-bg hover:bg-primary"
        title="{{ 'Info' | translate }}"
        (click)="folderPopover.toggle($event); $event.stopPropagation()">
        <i class="pi pi-info" style="font-size: 12px"></i>
      </span>
    </div>
  </div>
}
@if (data.type !== 'album') {
  <div class="flex justify-between w-full">
    <div class="overflow-wrap text-ellipsis truncate max-w-64">
      <i class="pi pi-{{ iconNameSet(data) }}"></i>
      {{
        data.name
          ? data.name
          : (data.file_name ? data.file_name : '') + (data.extension ? data.extension : '')
      }}
    </div>
    <div class="flex gap-1">
      <span
        *ngIf="
          data.media_file_type === 'image' ||
          data.media_file_type === 'video' ||
          data.media_file_type === 'audio'
        "
        class="w-6 h-6 text-center cursor-pointer rounded-full box-bg hover:bg-primary"
        title="{{ 'Show' | translate }}"
        (click)="toggleImagePopover($event, data.id + 'image'); $event.stopPropagation()">
        <i class="pi pi-eye" style="font-size: 12px"></i>
      </span>
      <span
        class="w-6 h-6 text-center cursor-pointer rounded-full box-bg hover:bg-primary"
        title="{{ 'Actions' | translate }}"
        (click)="actionsMenu.toggle($event); $event.stopPropagation()">
        <i class="pi pi-ellipsis-v" style="font-size: 12px"></i>
      </span>
      <span
        tooltipPosition="top"
        tooltipStyleClass="custom-tooltip"
        showDelay="1500"
        class="w-6 h-6 text-center cursor-pointer rounded-full box-bg hover:bg-primary"
        title="{{ 'Info' | translate }}"
        pTooltip="File name: {{ data.file_name }}{{ data.extension }} &#13;
        Description: {{ data.description }} &#13;
        Size: {{ (data.file_size || 0) / 1000000 | number: '1.2-2' }} Mb
      "
        (click)="togglePopover($event, data.id); $event.stopPropagation()">
        <i class="pi pi-info" style="font-size: 12px"></i>
      </span>
    </div>
  </div>
}
<p-popover #imagePopover [id]="data.id + 'image'">
  <div class="max-w-32">
    <div *ngIf="data.media_file_type === 'video'">
      <video controls autoplay muted>
        <source type="video/mp4" [src]="data.media_file_url" />
        <source type="video/avi" [src]="data.media_file_url" />
        <source type="video/webm" [src]="data.media_file_url?.replace('.mp4', '.webm')" />
        <source type="video/ogg" [src]="data.media_file_url?.replace('.mp4', '.ogv')" />
        {{ 'Your browser does not support the video tag.' | translate }}
      </video>
    </div>
    <div *ngIf="data.media_file_type === 'image'">
      <img
        src="{{ data.thumbnail_file_url ? data.thumbnail_file_url : data.media_file_url }}"
        alt="{{ data.file_name }}" />
    </div>
    <div *ngIf="data.media_file_type === 'audio'">
      <audio alt="Selectable" controls [src]="data.media_file_url"></audio>
    </div>
  </div>
</p-popover>
<p-popover #popover [id]="data.id">
  <div class="flex flex-col gap-4">
    <div>
      <h5 class="font-bold block mb-2">{{ 'File details' | translate }}:</h5>
    </div>
    <div>{{ 'File name' | translate }}: {{ data.file_name }}{{ data.extension }}</div>
    <div class="max-w-xs break-words whitespace-normal">
      {{ 'Description' | translate }}: {{ data.description }}
    </div>
    <div>{{ 'Size' | translate }}: {{ (data.file_size || 0) / 1000000 | number: '1.2-2' }} Mb</div>
  </div>
</p-popover>
<p-menu #foldersMenu [appendTo]="'body'" [popup]="true" [model]="folderMenuItems">
  <ng-template #start />
  <ng-template #submenuheader let-item>
    @if (item?.visible !== false) {
      <div class="text-blue-500 font-bold">
        {{ item.label }}
      </div>
    }
  </ng-template>
  <ng-template #item let-item>
    @if (item?.visible !== false) {
      <a class="flex items-center p-2 cursor-pointer gap-2">
        <span
          class="inline-flex items-center justify-center {{
            item?.icon_color ? item?.icon_color : 'text-blue-500'
          }}">
          <mat-icon fontIcon="{{ item.icon ? item.icon : 'add_circle' }}" />
        </span>
        <span class="inline-flex flex-col gap-2">
          <span class="font-light text-sm">{{ item.label }}</span>
        </span>
      </a>
    }
  </ng-template>
</p-menu>
<p-menu #actionsMenu [appendTo]="'body'" [popup]="true" [model]="menuItems">
  <ng-template #start />
  <ng-template #submenuheader let-item>
    @if (item?.visible !== false) {
      <div class="text-blue-500 font-bold">
        {{ item.label }}
      </div>
    }
  </ng-template>
  <ng-template #item let-item>
    @if (item?.visible !== false) {
      <a class="flex items-center p-2 cursor-pointer gap-2">
        <span
          class="inline-flex items-center justify-center {{
            item?.icon_color ? item?.icon_color : 'text-blue-500'
          }}">
          <mat-icon fontIcon="{{ item.icon ? item.icon : 'add_circle' }}" />
        </span>
        <span class="inline-flex flex-col gap-2">
          <span class="font-light text-sm">{{ item.label }}</span>
        </span>
      </a>
    }
  </ng-template>
</p-menu>
<p-dialog
  header="{{ 'Select a folder' | translate }}"
  [modal]="true"
  [closeOnEscape]="true"
  [resizable]="true"
  [appendTo]="'body'"
  [closable]="true"
  [dismissableMask]="true"
  [maximizable]="true"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [(visible)]="selectFolder"
  (onHide)="closeDialog()">
  <div class="p-2">
    <div class="pt-3">
      @if (selectFolder && data.type !== 'album') {
        <offconon-folder-tree
          [folderList]="folderList"
          [copyAction]="copyAction"
          [selected_file_id]="data.id"
          [selected_file_album_id]="data.album_id"
          (MovedFilesEmit)="closeDialog()" />
      }
      @if (selectFolder && data.type === 'album') {
        <offconon-folder-tree
          [folderList]="folderList"
          [copyAction]="copyAction"
          [selected_album_id]="data.id"
          [selected_file_album_id]="currentFolder.id"
          (MovedFilesEmit)="closeDialog()" />
      }
    </div>
  </div>
</p-dialog>
<p-dialog
  header="{{ 'Edit file properties' | translate }}"
  [modal]="true"
  [closeOnEscape]="true"
  [appendTo]="'body'"
  [resizable]="true"
  [closable]="true"
  [dismissableMask]="true"
  [maximizable]="true"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [(visible)]="editProperty"
  (onHide)="closePropertiesDialog()">
  <div class="p-2">
    <div class="pt-3">
      @if (editProperty) {
        <offconon-file-properties-form [data]="data" (formSavedEvent)="savedProperties($event)" />
      }
    </div>
  </div>
</p-dialog>
<p-confirmDialog
  [key]="'deleteMediaDialogCard-' + data.id"
  [breakpoints]="{ '960px': '75vw' }"
  [baseZIndex]="12"
  [appendTo]="'body'">
  <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
    <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
      <span class="font-bold text-2xl block mb-2 mt-6">{{ message?.header }}</span>
      <p class="mb-0">{{ message?.message }}</p>
      <div class="flex items-center gap-2 mt-6">
        <p-button label="{{ 'Yes, I want to delete it.' | translate }}" (onClick)="onAccept()" />
        <p-button label="{{ 'Cancel' | translate }}" [outlined]="true" (onClick)="onReject()" />
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
<p-dialog
  header="{{ 'Edit folder' | translate }}"
  [appendTo]="'body'"
  [modal]="true"
  [closeOnEscape]="true"
  [resizable]="true"
  [closable]="true"
  [dismissableMask]="true"
  [maximizable]="true"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [(visible)]="editFolder"
  (onHide)="onlyCloseEditDialog()">
  <div class="p-2">
    <div class="pt-3">
      @if (editFolder) {
        <offconon-media-folder-form-common
          [edit_id]="data.id"
          [album_id]="data.id"
          [name]="data.name"
          (formSavedDataEvent)="savedForm($event)" />
      }
    </div>
  </div>
</p-dialog>
<p-confirmDialog
  [key]="'deletefolder-' + data.id"
  [breakpoints]="{ '960px': '75vw' }"
  [baseZIndex]="12"
  [appendTo]="'body'">
  <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
    <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
      <span class="font-bold text-2xl block mb-2 mt-6">{{ message?.header }}</span>
      <p class="mb-0">{{ message?.message }}</p>
      <div class="flex items-center gap-2 mt-6">
        <p-button label="{{ 'Yes, I want to delete it.' | translate }}" (onClick)="onAccept()" />
        <p-button label="{{ 'Cancel' | translate }}" [outlined]="true" (onClick)="onReject()" />
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
<p-popover #folderPopover>
  <div class="flex flex-col">
    <div class="font-bold mb-3">{{ 'Folder details' | translate }}:</div>
    <div class="text-gray text-sm">
      <div>{{ 'Folder name' | translate }}: {{ data.name }}</div>
      <div
        *ngIf="data.description && data.description !== ''"
        class="max-w-xs break-words whitespace-normal">
        {{ 'Description' | translate }}: {{ data.description }}
      </div>
      <div class="max-w-xs break-words whitespace-normal">
        {{ 'Items' | translate }}: {{ data.items_count }}
      </div>
      <div *ngIf="data.total_file_size && data.total_file_size > 0">
        {{ 'Total size' | translate }}:
        {{ (data.total_file_size || 0) / 1000000 || 0 | number: '1.2-2' }} Mb
      </div>
    </div>
  </div>
</p-popover>
